export default __webpack_public_path__ + "606f223774ed8d912df43c5702d3266037c1770c222130ff2bbff2b56d1b210b.svg";